<p-contextmenu #cm [model]="_contextMenu" (onHide)="_contextMenuSelection = null" appendTo="body" />

<p-table
    #ptable
    stripedRows
    [loading]="showLoading"
    [value]="_items"
    stripedRows
    [resizableColumns]="true"
    [autoLayout]="true"
    [scrollable]="true"
    [scrollHeight]="'flex'"
    columnResizeMode="expand"
    [reorderableColumns]="true"
    [contextMenu]="cm"
    [(contextMenuSelection)]="_contextMenuSelection"
    (onContextMenuSelect)="onContextMenuSelect($event.data!)"
>
    <ng-template pTemplate="caption">
        <div class="header-flex">
            <div style="display: flex; gap: 0.5rem">
                <div style="width: 20rem; display: inline-block">
                    <p-iconfield>
                        <p-inputicon class="pi pi-search" />
                        <input
                            [id]="'SearchBar'"
                            pInputText
                            type="text"
                            [value]="_searchValue ?? ''"
                            (input)="ptable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="Search words"
                        />
                    </p-iconfield>
                </div>
            </div>

            <div class="caption-buttons">
                <p-button severity="secondary" icon="pi pi-refresh" (click)="refresh()" />
                <p-button
                    severity="primary"
                    icon="pi pi-folder-plus"
                    (click)="onCreateDirectory()"
                    pTooltip="Create directory"
                    tooltipPosition="left"
                    [disabled]="!_authorizationCreateDir"
                />
                <p-button
                    severity="primary"
                    icon="pi pi-upload"
                    (click)="onUploadFile()"
                    pTooltip="Upload file(s)"
                    tooltipPosition="left"
                    [disabled]="!(_authorizationUpload && _authorizationCreateFile)"
                />
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="name" pResizableColumn pReorderableColumn [ngStyle]="{width: '65%'}">
                {{ 'Name' | titlecase }}
                <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="size" pResizableColumn pReorderableColumn>
                {{ 'Size' | titlecase }}
                <p-sortIcon field="size"></p-sortIcon>
            </th>
            <th pSortableColumn="created_at" pResizableColumn pReorderableColumn>
                {{ 'Created At' | titlecase }}
                <p-sortIcon field="created_at"></p-sortIcon>
            </th>
            <th pSortableColumn="created_by_uuid" pResizableColumn pReorderableColumn>
                {{ 'Created By' | titlecase }}
                <p-sortIcon field="created_by_uuid"></p-sortIcon>
            </th>

            <th [ngStyle]="{width: '3rem'}" alignFrozen="right" pFrozenColumn></th>
        </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody">
        @for (idx of [0, 1, 2, 3, 4, 5]; track idx) {
            <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
            </tr>
        }
    </ng-template>

    <ng-template pTemplate="loadingicon">
        <p-progress-spinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progress-spinner>
        <div class="mt-2 mb-2" [ngStyle]="{color: 'white', fontSize: '1.5rem', fontWeight: 'bold'}">
            {{ loadingStr }}
        </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="50">
                @if (_items.length === 0 && !showError) {
                    <p-message severity="warn">There is nothing to show.</p-message>
                }
                @if (showError) {
                    <p-message severity="warn">An error occured while getting datas.</p-message>
                }
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
        <tr [pContextMenuRow]="row">
            <td>
                @if (row === _moveUpEntry) {
                    <a
                        tabindex="0"
                        role="button"
                        (click)="navigateUp()"
                        (keydown.enter)="navigateUp()"
                        (keydown.space)="$event.preventDefault(); navigateUp()"
                        class="hcol-flex"
                        [ngStyle]="{gap: '0.25rem'}"
                    >
                        <span class="pi pi-directions-alt"></span>
                        <i>{{ row.name }}</i>
                    </a>
                } @else if (row.is_dir) {
                    <a
                        tabindex="0"
                        role="button"
                        (click)="navigateTo(row)"
                        (keydown.enter)="navigateTo(row)"
                        (keydown.space)="$event.preventDefault(); navigateTo(row)"
                        class="hcol-flex"
                        [ngStyle]="{gap: '0.25rem'}"
                    >
                        <span class="pi pi-folder"></span>
                        {{ row.name }}
                    </a>
                } @else {
                    <span class="pi pi-file"></span>
                    {{ row.name }}
                }
            </td>
            <td>{{ row._formated_size }}</td>
            <td>{{ row.created_at | date }}</td>
            <td>
                <app-user-data-cell-display
                    displayType="table"
                    [rows]="_items"
                    [row]="row"
                    attribute="created_by_uuid"
                    [value]="row.created_by_uuid"
                />
            </td>
            <td [ngStyle]="{textAlign: 'right'}">
                @if (!row.is_dir) {
                    <p-button
                        severity="secondary"
                        icon="pi pi-download"
                        size="small"
                        (click)="downloadFile(row)"
                        [disabled]="!_authorizationDownload"
                    />
                }
                <p-button
                    severity="secondary"
                    (click)="onContextMenuSelect(row); cm.show($event)"
                    icon="pi pi-ellipsis-h"
                    size="small"
                />
            </td>
        </tr>
    </ng-template>
</p-table>
